import Vue from 'vue'

const start = (filters) => {
  return Vue.prototype.$http.post('exports', filters)
}

export default {
  start,
}
